export default __webpack_public_path__ + "static/media/FSMeridian-Thin.4facef5f.woff2";